import React, { Component } from 'react';
import { TimelineMax, Power1, Back } from "gsap/all";

class Home extends Component {
  constructor(props) {
    super(props);
    this.timeline = new TimelineMax({ paused: true });
  }
  componentDidMount() {
    window.scrollTo(0, 0);
    this.timeline
      .from(this.header, 0.5, {
        display: "none",
        autoAlpha: 0,
        delay: 0.25,
        ease: Power1.easeIn
      })
      .from(this.content, 0.4, {
        autoAlpha: 0,
        y: 25,
        ease: Power1.easeInOut
      });

    this.timeline.play();
  }
  render() {
    return (
      <div className="view-page-container home-page text-center">
        <h1 ref={div => (this.header = div)}>Hello,</h1>
        <h1 ref={div => (this.content = div)}>This is Mac (Mackral) <br />
        Welcome to my page!</h1>
      </div>
    );
  }
}
export default Home;
